import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { tap, take, switchMap, catchError, map } from 'rxjs/operators';
import {
  AuthFacade,
  User
} from '@ecosure-suite/back-office/auth/data-access-auth';

import { JwtService } from '@ecosure-suite/shared/util-auth';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private jwtService: JwtService,
    private router: Router,
    private authService: AuthFacade
  ) {}

  getUser(): Observable<any> {
    return this.authService.user$.pipe(
      tap((user: User) => {
        if (user === null || user === undefined) {
          this.authService.getUserDetails();
        }
      }),
      map((user: User) => !!user),
      take(1)
    );
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.hasValidAccessToken()) {
      return this.getUser().pipe(
        switchMap(() => of(true)),
        catchError(() => of(false))
      );
    }
    this.router.navigate(['/login']);
    return false;
  }
}
